import './Control.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var expandButtonCSS = _7a468({defaultClassName:'_1b34gxt0-2-0-1',variantClassNames:{isFocusVisible:{true:'_1b34gxt1-2-0-1',false:'_1b34gxt2-2-0-1'}},defaultVariants:{},compoundVariants:[]});